// assets
import { RocketOutlined } from "@ant-design/icons";
import Permissions from "constants/Permissions";

// icons
const icons = {
    RocketOutlined,
};

// ==============================|| MENU ITEMS - UAV ||============================== //

const unmanned_aerial_vehicles = {
    id: "group-managed-assets",
    title: "Jurisdiction",
    type: "group",
    appModule: "JURISDICTION",
    children: [
        {
            id: "managed-assets",
            title: "Managed Assets",
            authority: Permissions.DashboardSection.Dashboard,
            type: "item",
            url: "/managed-assets",
            icon: icons.RocketOutlined,
            breadcrumbs: false,
        },
    ],
};

export default unmanned_aerial_vehicles;
